import { useLayoutEffect } from 'react';
import { MotionConfig, MotionGlobalConfig } from 'framer-motion';
import { INSTANT_MOTION_HTML_CLASS } from '../lib/instantMotion.js';
import { useInstantMotion } from '../hooks/useInstantMotion';

/**
 * Phone / A2HS: skip Framer transform slides and mark html for CSS scale/blur kill.
 * reducedMotion only snaps positional keys. skipAnimations also snaps opacity
 * so route changes do not fade the page.
 */
export function InstantMotionRoot({ children }) {
  const instant = useInstantMotion();

  // React runs child useLayoutEffect before this parent's, so a layout-effect
  // write is too late for a route enter that starts in the same commit.
  // Assigning during render is idempotent (Strict Mode invokes render twice
  // with the same instant value). The layout effect below re-asserts on
  // commit and clears the flag on cleanup. See InstantMotionRoot.test.jsx.
  MotionGlobalConfig.skipAnimations = instant;

  // useLayoutEffect: apply before first paint so /login does not render a
  // scaled tile then snap to transform:none after the effect flush.
  useLayoutEffect(() => {
    document.documentElement.classList.toggle(INSTANT_MOTION_HTML_CLASS, instant);
    MotionGlobalConfig.skipAnimations = instant;
    return () => {
      document.documentElement.classList.remove(INSTANT_MOTION_HTML_CLASS);
      MotionGlobalConfig.skipAnimations = false;
    };
  }, [instant]);

  return (
    <MotionConfig reducedMotion={instant ? 'always' : 'user'}>
      {children}
    </MotionConfig>
  );
}
